import { Typography } from "@mui/material";
import { GridOverlay } from "@mui/x-data-grid";
import theme, { responsiveFontSize } from "themes/Theme";
interface IProps {
  title: string;
}
const NoRowsTableDataOverlay: React.FC<IProps> = ({ title }) => {
  return (
    <GridOverlay>
      <Typography
        sx={{
          fontSize: responsiveFontSize(14),
          color: theme.palette.text.secondary,
        }}
      >
        {title}
      </Typography>
    </GridOverlay>
  );
};

export default NoRowsTableDataOverlay;
